var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"answer mb-3"},[_vm._v(_vm._s(_vm.$t('faqTab.gettingStarted.questions.alreadyUsingVpnA1')))]),_c('p',{staticClass:"answer mb-0"},[_vm._v(_vm._s(_vm.$t('faqTab.gettingStarted.questions.alreadyUsingVpnA2')))])])}
var staticRenderFns = []

export { render, staticRenderFns }